import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReducersTypes } from '@/redux/reducers/Models';
import { clearCustomer } from '@/redux/ducks/customer';
import { clearUser } from '@/redux/ducks/user';

/**
 * Componente que monitora mudanças no hash da URL globalmente
 * Se detectar hash siga-facil ou zapay, faz logout completo e redireciona para /
 * Deve estar dentro do Router para usar useNavigate e useLocation
 */
const HashMonitor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const lastProcessedHash = useRef<string | null>(null);

  useEffect(() => {
    const checkHash = () => {
      const hash = window.location.hash;
      
      const isSigaFacilHash = hash && hash.includes('#siga-facil') && hash.includes('?');
      const isZapayHash = hash && hash.includes('#zapay') && hash.includes('?');
      
      if (isSigaFacilHash || isZapayHash) {
        const queryString = hash.split('?')[1];
        const hashParams = new URLSearchParams(queryString);
        const hashValue = hashParams.get("q");
        
        if (hashValue && hashValue !== lastProcessedHash.current) {
          lastProcessedHash.current = hashValue;
          
          if (customer?.accessToken || customer?.client?.id || customer?.refreshToken) {
            dispatch(clearCustomer());
            dispatch(clearUser());
          }
          
          if (location.pathname !== '/') {
            navigate('/', { replace: true });
          }
        }
      } else {
        lastProcessedHash.current = null;
      }
    };

    checkHash();

    window.addEventListener('hashchange', checkHash);

    return () => {
      window.removeEventListener('hashchange', checkHash);
    };
  }, [customer?.accessToken, customer?.client?.id, customer?.refreshToken, dispatch, navigate, location.pathname]);

  return null;
};

export default HashMonitor;
